export enum TicketCardType {
  VENTA = 1,
  Cortesia = 2,
  Rifa = 3,
  Precargada = 4,
  Invitado = 5,
  Promocional = 6,
  VentaManual = 7,
}

export const getTicketCardTypeBody = (type: number) => {
  let tagColor = "";
  let tagTextColor = "";
  let tagText = "";

  switch (type) {
    case TicketCardType.VentaManual:
      tagColor = "bg-purple-200";
      tagTextColor = "text-purple-700";
      tagText = "Manual";
      break;
    case TicketCardType.VENTA:
      tagColor = "bg-blue-100";
      tagTextColor = "text-blue-700";
      tagText = "Cajero";
      break;
    default:
      tagColor = "bg-pink-100";
      tagTextColor = "text-pink-700";
      tagText = "Cortesía";
      break;
  }

  return { tagColor, tagTextColor, tagText };
};

export const getTicketCardActionBody = (type: string) => {
  let tagColor = "";
  let tagTextColor = "";

  switch (type) {
    case "Cajero":
      tagColor = "bg-purple-200";
      tagTextColor = "text-purple-700";
      break;
    case "Compra":
      tagColor = "bg-blue-100";
      tagTextColor = "text-blue-700";
      break;
    case "Recarga":
      tagColor = "bg-green-100";
      tagTextColor = "text-green-700";
      break;
    case "Reembolso":
      tagColor = "bg-yellow-100";
      tagTextColor = "text-yellow-700";
      break;
    case "Reverso":
      tagColor = "bg-red-100";
      tagTextColor = "text-red-700";
      break;
    default:
      tagColor = "bg-pink-100";
      tagTextColor = "text-pink-700";
      break;
  }

  return { tagColor, tagTextColor, tagText: type };
};
